import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'assignment_requests',
  inputShow: gql`
    query assignmentRequests($input: AssignmentRequestQueryInput) {
      assignmentRequests(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Misc',
    label: 'Assignment Requests',
  },
};
